/**
 * @file Alert atom — inline status message family.
 * @description structured atom: compound parts re-exported from the vendored
 * Gluestack family; this is the only sanctioned import path for app code
 * (RFC §3).
 * @module components/atoms/Alert
 */
export { UIAlert, Alert, AlertText, AlertIcon } from "@/components/ui/alert";
